<template>
    <li class="dailyOverviewItem flex flex-column-ns">
        <div v-if="isNextDay" class="flex flex-column flex-row-ns tc mr3 mr0-ns
            w-100-ns justify-center justify-between-ns items-center">
            <span class="gray mt4-ns mb1-ns">{{ getWeekday() }}</span>
        </div>

        <div class="flex flex-column
        flex-row-ns tc mr3 mr0-ns w-100-ns justify-between items-center">
            <span class="dib-ns w3-ns tl-ns">{{ label }}</span>
            <div class="dailyOverviewItem__icon mt1 mt0-ns">
                <svgicon :name="hourInfo.icon"
                :color="$root.getColorForIcon(hourInfo.icon)"></svgicon>
            </div>
            <span class="mt1 mt0-ns">{{ temperature }}</span>
        </div>
    </li>
</template>

<script>

export default {
    name: 'DailyOverviewItem',
    props: {
        hourInfo: Object,
    },
    methods: {
        getIconPath(iconName) {
            return require(`../assets/icons/${iconName}.svg`); // eslint-disable-line
        },
        getWeekday() {
            const formatter = new Intl.DateTimeFormat(this.$root.lang, {
                weekday: 'long',
            });
            return formatter.format(new Date(this.hourInfo.time * 1000));
        },
    },
    computed: {
        label() {
            const d = new Date(this.hourInfo.time * 1000);
            const formatter = new Intl.DateTimeFormat(this.$root.lang, {
                hour: 'numeric',
            });
            return formatter.format(d);
        },
        temperature() {
            return Math.round(this.hourInfo.temperature);
        },
        isNextDay() {
            const forecastDay = new Date(this.hourInfo.time * 1000);
            const today = new Date();
            if (forecastDay.getDate() > today.getDate() && forecastDay.getHours() === 0) {
                return true;
            }
            return false;
        },
    },
};
</script>

<style lang="scss">
@import '../styles/variables';

.dailyOverviewItem__icon svg {
    width: 3rem;
    height: 3rem;
    transform: scale(1.2);

    @media screen and (min-width: $breakpoint-small) {
        height: 2rem;
        width: 2rem;
    }
}
</style>
